<template>
  <div class='teaReport'>
    <template v-if="type==3">
      <!--课堂互动-->
        <class-interaction></class-interaction>
    </template>
    <template v-else>
     <div class="bgWhite"></div>
     <div style="position:relative">
        <template v-if="type==1&&list.length>0">
          <div class='btn' @click="gotoUrl('classRank')" v-if='from!=="app"'>班级<br>排名</div>
          <days @getdays='getDays'></days>
          <div class="list skip">
             <div class='flex-center top'>
                <p>排名</p>
                <p>姓名</p>
                <p>时长(分钟)</p>
                <p>个数</p>
             </div>
             <div v-for="(item,i) in list" :key='i' class="flex-center">
                 <p :class='"num"+item.ranking'>{{item.ranking}}</p>
                 <p>{{item.studentName}}</p>
                 <p>{{item.skipTimes||'0'}}</p>
                 <p>{{item.skipNums||'0'}}</p>
             </div>
           </div>
        </template>
        
        <template v-if='type==2&&list.length>0'>
           <div class="list">
             <div class='flex-center top'>
                <p>排名</p>
                <p>姓名</p>
                <p>本周打卡</p>
                <p>本学期打卡</p>
             </div>
             <div v-for="(item,i) in list" :key='i' class="flex-center" @click="gotoUrl('clockInDetail',item)">
                 <p :class='"num"+item.ranking'>{{item.ranking}}</p>
                 <p>{{item.studentName}}</p>
                 <p>{{item.beaconWeekNums||'0'}}</p>
                 <p>{{item.beaconTermNums||'0'}}<van-icon name="arrow" class='arrow' /></p>
             </div>
           </div>
        </template>
        <div class='noData' v-if="text&&list.length==0"><div><img :src='require("@/assets/img/nodata.png")'><br />{{text}}</div></div>
     </div>
    </template>
  </div>
</template>
<script>
import days from '@/components/dateTop.vue';
import classInteraction from './classInteraction.vue';
import {getStudentSkipReport,getStudentBeaconReportList} from "@/api/api.report";
  export default {
    data() {
      return {
        date:new Date(),
        type:this.$route.query.type||sessionStorage.type,//1 跳绳 2打卡,
        classId:this.$route.query.classId,
        list:[],
        text:'',
        from:''
      }
    },
   components:{days,classInteraction},
   created(){
  
     let date=new Date();
     this.date=this.pubMethod.formatDate(date,'yyyy-MM-dd');
     this.week=date.getDay();
     if(this.type==1){
      //  document.title='智慧跳绳';
       this.getSkip();
     }else if(this.type==2){
      //  document.title='实践打卡';
       this.getList();
     }
     sessionStorage.setItem('type',this.type);
    },
    methods: {
       getList(){
         getStudentBeaconReportList({
              classId:this.classId,
              reportDate:this.date
           }).then((data) => {
            if (data && data.result.length>0) {
                  this.list=data.result
            }else{
              this.text='暂无数据';
            }
         })
       },
       getSkip(){
         
         getStudentSkipReport({
              classId:this.classId,
              reportDate:this.date
           }).then((data) => {
            if (data && data.result.length>0) {
                  this.list=data.result
            }else{
              this.text='暂无数据';
            }
         })
       },
       getDays(item){
         this.date=item.date;
         this.getSkip();
       },
       
    },
  }
</script>
<style lang="scss" >
.teaReport{
  min-height: 100%;
  .bgWhite{
    position: fixed;
    background: #fff;
    width: 100%;
    height: 100%;
    top: 0px;
    left: 0px;
  }
  .btn{
    color: #fff;
    border-radius: 50%;
    background: #0672e8;
    position: fixed;
    right: 10px;
    bottom: 20px;
    width: 60px;
    height: 60px;
    display: flex;
    align-items: center;
    justify-content: center;
    // width:80px;
    // padding:20px;
    text-align: center;
    font-size: .16rem;
  }
  .skip{
    padding-top: 78px;
  }
  .list{
     line-height: .55rem;
     font-size: .15rem;
     color:#7f7f7f;
     
     div{
       p{
         flex: 1;
         text-align: center;
         overflow: hidden;
         white-space: nowrap;
         text-overflow: ellipsis;
         img{
           width:.26rem;
           vertical-align: middle;
         }
         .arrow{
           margin-left: 10px;
         }
       }
     }
     .top{
        margin-bottom: 5px;
        img{
            width:16px;
        }
     }
     .num1{
       background:url(../../assets/img/step/num1.png) no-repeat center top;
       background-size:.26rem auto ;
       width:.26rem;
       line-height: .26rem;
       color:#fff;
     }
     .num2{
       background:url(../../assets/img/step/num2.png) no-repeat center top;
       background-size:.26rem auto ;
       width:.26rem;
       line-height: .26rem;
       color:#fff;
     }
     .num3{
       background:url(../../assets/img/step/num3.png) no-repeat center top;
       background-size:.26rem auto ;
       width:.26rem;
       line-height: .26rem;
       color:#fff;
     }
  }
@media screen and (max-width:400px){
  .list div p{
       &:first-child{
           flex:0 0 50px;
         }
  }
}
}

</style>